module.exports = __webpack_public_path__ + "static/media/BlueRing.2a1a7d2f.svg";